import { Button } from "@loot-os/ui/components/button";

import type { BoxStatus } from "../lib/boxEditor";

/**
 * Draft / pre-release / active, for either editor. Activating needs a published version — the
 * server enforces it, so the button simply isn't offered. An archived box offers its way back to
 * draft; archiving itself is in the ⋯ menu beside Delete.
 */
export function BoxStatusActions({
  status,
  currentVersion,
  onSetStatus,
  pending,
}: {
  status: BoxStatus;
  currentVersion: number;
  onSetStatus: (status: BoxStatus) => void;
  pending: boolean;
}) {
  if (status === "archived") {
    return (
      <Button
        type="button"
        variant="outline"
        onClick={() => onSetStatus("draft")}
        disabled={pending}
      >
        Restore to draft
      </Button>
    );
  }
  if (status === "active") {
    return (
      <>
        <Button
          type="button"
          variant="outline"
          onClick={() => onSetStatus("draft")}
          disabled={pending}
        >
          Set draft
        </Button>
        <Button
          type="button"
          variant="outline"
          onClick={() => onSetStatus("pre_release")}
          disabled={pending}
        >
          Set pre-release
        </Button>
      </>
    );
  }
  return (
    <>
      {currentVersion > 0 ? (
        <Button
          type="button"
          variant="outline"
          onClick={() => onSetStatus("active")}
          disabled={pending}
        >
          Activate
        </Button>
      ) : null}
      <Button
        type="button"
        variant="outline"
        onClick={() => onSetStatus(status === "pre_release" ? "draft" : "pre_release")}
        disabled={pending}
      >
        {status === "pre_release" ? "Set draft" : "Set pre-release"}
      </Button>
    </>
  );
}
